<script lang="ts">
    import { Pagination, PaginationItem, PaginationLink,Col, Container, Row } from "sveltestrap";
    import {  href, Next, Previous } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
    import PaginationWithIcons from "./PaginationWithIcons.svelte";
    import PaginationAlignment from "./PaginationAlignment.svelte";
    import PaginationSizing from "./PaginationSizing.svelte";
    import PaginationColor from "./PaginationColor.svelte";
    import PaginationActiveAndDisabled from "./PaginationActiveAndDisabled.svelte";
    import BookmarkPagination from "./BookmarkPagination.svelte";
   
</script>
<BookmarkPagination />
<Container fluid>
  <Row>
    <Col xl="6">
      <Card headerTitle="Pagination" cardHeaderprops="pb-0">
        <div slot="contentbody">
          <Pagination
            aria-label="Page navigation example"
            class="pagination-primary">
            <PaginationItem>
              <PaginationLink {href}>{Previous}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink {href}>{'1'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink {href}>{'2'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink {href}>{'3'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink {href}>{Next}</PaginationLink>
            </PaginationItem>
          </Pagination>
        </div>
      </Card>
    </Col>
    <PaginationWithIcons />
    <PaginationAlignment />
    <PaginationActiveAndDisabled />
    <PaginationColor />
    <PaginationSizing />
  </Row>
</Container>
